import { render, staticRenderFns } from "./DpiNew.vue?vue&type=template&id=02c4e57d"
import script from "./DpiNew.vue?vue&type=script&lang=js"
export * from "./DpiNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports